import axios from "axios";
import notify from "devextreme/ui/notify";

export const instance = axios.create({
  timeout: 10000
});

export const getPlanList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/study/plan"
  });
  return response;
};

export const getPlanListActual = () => {
  const response = instance({
    method: "get",
    url: "/work/api/study/plan-actual"
  });
  return response;
};

export const getPlanListActualByProgram = (programId) => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan-actual/${programId}`
  });
  return response;
};

export const getPlanCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan/${id}/card`
  });
  return response;
};

export const getPlanSystem = id => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan/${id}`
  });
  return response;
};

export const getPlanMain = id => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan/${id}/main`
  });
  return response;
};

export const getGroupList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/3?arg=${id}`
  });
  return response;
};

export const getPlanGroups = id => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan/${id}/group`
  });
  return response;
};

export const createPlan = data => {
  const response = instance({
    method: "post",
    url: `/work/api/study/plan`,
    data
  });
  return response;
};

export const updatePlan = (id, main) => {
  const response = instance({
    method: "put",
    url: `/work/api/study/plan/${id}`,
    data: { main: main }
  });
  return response;
};

export const createGroup = (planId, data) => {
  const main = {
    ...data,
    plan: planId
  };

  const response = instance({
    method: "post",
    url: `/work/api/group`,
    data: main
  });
  return response;
};

export const updateGroup = (id, main) => {
  const response = instance({
    method: "put",
    url: `/work/api/group/${id}`,
    data: { main: main }
  });
  return response;
};

export const deletePlan = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/study/plan/${id}`
  });
  return response;
};

export const deletePlanGroup = (id, groupId) => {
  const data = {
    type: "removeGroup",
    id: id,
    groupId: groupId
  };
  const response = instance({
    method: "post",
    url: "/work/api/study/plan/rpc",
    data
  });
  return response;
};

export const getEducationOrgList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/organization?mode=select&offerEducation=true"
  });
  return response;
};

export const getProgramList = orgId => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/2?arg=${orgId}`
  });
  return response;
};

export const getActualProgramList = orgId => {
  const response = instance({
    method: "get",
    url: `/work/api/actual-programs/${orgId}`
  });
  return response;
}

export const getPlanWaitingList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/study/plan/${id}/waiting`
  });
  return response;
};

export const setGroup = (id, groupId) => {
  const data = {
    type: "setGroup",
    id: id,
    groupId: groupId
  };
  const response = instance({
    method: "post",
    url: "/work/api/request-program/rpc",
    data
  });
  return response;
};

export const changeStatusPlan = (planId, type) => {
  const data = {
    type : type,
    id : planId
  };

  const response = instance({
    method: "post",
    url: `/work/api/study/plan/rpc`,
    data
  });
  return response;
}

export default {
  getPlanList,
  getPlanListActual,
  getPlanListActualByProgram,
  getPlanCard,
  getPlanMain,
  getPlanSystem,
  getPlanGroups,
  getGroupList,
  createPlan,
  deletePlan,
  updatePlan,
  createGroup,
  updateGroup,
  getEducationOrgList,
  getProgramList,
  getActualProgramList,
  deletePlanGroup,
  getPlanWaitingList,
  setGroup,
  changeStatusPlan
};
